export enum ServiceEndpointTypes {
    LEGACY = "1",
    OIDC = "2",
    OIDC_FLAT = "3"
}